import Article, {
  ArticleContentBox,
  DisclaimerBox,
  DisclaimerText,
  DisclaimerTitle,
} from '../../shared_components/Library/Article'
import { H3, P, Strong } from '../../shared_components/Library/Typeography'
import { Box } from '../../shared_components/UI/Box'
import { ThemedAnchor, ThemedLink } from '../../shared_components/ThemedButton'
import routes from '../../router/routes'
import Rocket02 from '../../shared_components/Icons/Rocket02'
import CoinSwap01 from '../../shared_components/Icons/CoinSwap01'
import LineChartUp01 from '../../shared_components/Icons/LineChartUp01'

const ZapLaunchArticle = () => {
  return (
    <Article
      bannerUrl="/memecoin-launcher/how-it-works-banner.png"
      title="Meet ZAP Launch. The ultimate way to discover and launch trending tokens"
      content={
        <>
          <ArticleContentBox>
            <H3 fw="semibold">Why ZAP Launch?</H3>
            <P c="text-secondary">
              <Strong>Always safe.</Strong> All tokens use our audited, secure
              smart contracts, so you never have to worry about rugs.
            </P>
            <P c="text-secondary">
              <Strong>Always liquid.</Strong> No vesting. When you buy tokens on
              ZAP Launch, you can sell them at any time.
            </P>
            <P c="text-secondary">
              <Strong>Always fair.</Strong> All tokens launch with the same
              supply (1bn) and the same tokens for liquidity (200m). Say goodbye
              to insider trading, and getting dumped on by previous buyers.
            </P>
          </ArticleContentBox>
          <ArticleContentBox>
            <H3 fw="semibold">How it Works</H3>
            <P c="text-secondary">
              <Box g={10}>
                <Rocket02 color="white" />
                Tokens are deployed for as little as $3.
              </Box>
            </P>
            <P c="text-secondary">
              <Box g={10}>
                <CoinSwap01 color="white" />
                Tokens are then traded on ZAP Launch. Buys raise the price,
                sells lower it.
              </Box>
            </P>
            <P c="text-secondary">
              <Box g={10}>
                <LineChartUp01 color="white" />
                When the bonding curve hits a market cap of 4 ETH, liquidity and
                leftover tokens migrate to the DEX for public trading.
              </Box>
            </P>
          </ArticleContentBox>
          <DisclaimerBox>
            <DisclaimerTitle>Disclaimer</DisclaimerTitle>
            <DisclaimerText>
              Tokens available on this platform are not supported by ZAP. ZAP is
              not an investment service; tokens can lose significant value at
              any moment. By using ZAP, you accept all associated risks and
              agree to our{' '}
              <a
                href="https://docs.zap.tech/zaponchain/other/terms-and-conditions"
                target="_blank"
                rel="noreferrer"
              >
                Terms and Conditions
              </a>
              .
            </DisclaimerText>
          </DisclaimerBox>
          <Box g={10} ac fw>
            <ThemedLink to={routes.memecoins.launcher} $styleType="primary">
              Launch a token
            </ThemedLink>
            <ThemedAnchor
              $styleType="tertiary"
              p="11px 20px 11px 16px"
              href="https://discord.gg/zaponchain"
            >
              <img
                src="/supported-socials/discord.svg"
                alt="ZAP Discord"
                height="20px"
                width="20px"
                style={{ borderRadius: '50%' }}
              />
              Discord
            </ThemedAnchor>
            <ThemedAnchor
              $styleType="tertiary"
              p="11px 20px 11px 16px"
              href="https://x.com/zaponchain"
            >
              <img
                src="/supported-socials/twitter.svg"
                alt="ZAP X"
                height="20px"
                width="20px"
                style={{ borderRadius: '50%' }}
              />
              X
            </ThemedAnchor>
          </Box>
        </>
      }
    />
  )
}

export default ZapLaunchArticle
